<div #container  [ngClass]="['icc-toast-message-' + message.severity, 'icc-toast-message']" [class.icc-toast-message-highlighted]="message.highlighted" [@messageState]="{value: 'visible', params: {showTransformParams: showTransformOptions, hideTransformParams: hideTransformOptions, showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions}}"
        (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="icc-toast-message-content" role="alert" aria-live="assertive" aria-atomic="true">
        <icc-icon class="icc-toast-message-icon" [name]="getIcon(message)"></icc-icon>
        <div class="icc-toast-message-text">
            <div class="icc-toast-summary">{{message.title}}</div>

            <div *ngIf="!detailMore" class="icc-toast-detail" [innerHtml]="message.body"></div>

            <div
                *ngIf="message?.bodyExpansion && detailMore"
                class="icc-toast-detail"
                [innerHtml]="message.bodyExpansion"
            ></div>

            <div class="icc-toast-department" *ngIf="message?.showDepartment && message?.departmentName">
                <p iccBadgeChip appearance='outline' >
                    {{ message?.departmentName }}
                </p>
            </div>

            <a *ngIf="message?.bodyExpansion && !detailMore" (click)="detailMore = true">{{ 'INTERFACE|Więcej' | translate }}</a>
            <a *ngIf="message?.bodyExpansion && detailMore" (click)="detailMore = false">{{ 'INTERFACE|Mniej' | translate }}</a>

        </div>

        <button type="button" iccIconButton appearance="flat-base"
            class="icc-toast-icon-close p-link"
            (click)="onCloseIconClick($event)"
            (keydown.enter)="onCloseIconClick($event)">
            <icc-icon name="close"></icc-icon>
        </button>

    </div>

    <div *ngIf="message?.buttons?.length" class="icc-toast-buttons">

        <button
            *ngFor="let button of message.buttons"
            type="button"
            iccButton
            (click)="button.onClick(); onCloseIconClick($event);"
            (keydown.enter)="button.onClick(); onCloseIconClick($event);"
        >
            {{button.title}}
        </button>

    </div>

</div>